// import ajax from "./ajax";

import ajax from "./ajax"
import ajaxFile from "./ajax"

// const baseUrl = 'http://192.168.0.23:8081/api'
const baseUrl = 'https://pongo.net.cn/api'

// 轮播图文案
export const getBanner = (page, category) => ajax(baseUrl+`/content/${page}/${category}`, {}, 'GET')

// 首页文案
export const getText = (page) => ajax(baseUrl+`/content/${page}`, {}, 'GET')

// 获取视频链接
export const getVideo = (key) => ajax(baseUrl+`/video/${key}`, {}, 'GET')

// 获取视频详情
export const getVideos = (category) => ajax(baseUrl+`/videos/${category}`, {}, 'GET')

// 获取图片
export const getImg = (category) => ajax(baseUrl+`/images/${category}`, {}, 'GET')

// 获取用户信息
export const getUserInfo = (obj) => ajax(baseUrl+'/user/details',{}, 'GET', null, obj.token)

// 修改用户信息
export const changeUserInfo = (obj, token) => ajax(baseUrl+'/user/details', obj, 'POST', null, token)

// 检查是否重复
export const checkRepeat = (strName, str, token) => ajax(baseUrl+'/details/unique?'+strName+'='+str, {}, 'GET', null, token)

// 获取用户模型
export const getUserModel = (obj, token) => ajax(baseUrl+'/user/model', obj, 'GET', null, token)

// 获取用户收藏
export const getUserCollect = (obj, token) => ajax(baseUrl+'/user/favorite', obj, 'GET', null, token)

// 添加用户模型
export const addUserModel = (obj, token) => ajax(baseUrl+'/user/model', obj, 'POST', null, token)

// 取消/添加用户收藏
export const changeCollectState = (id, obj, token) => ajax(baseUrl+`/user/model/${id}/favorite`, obj, 'POST', null, token)

// 浏览量不变
export const getModelByIdNoView = (id, token) => ajax(baseUrl+`/user/model/${id}`, {}, 'GET', null, token)

// 查询单个模型，浏览量+1
export const getModelById = (id, token) => ajax(baseUrl+`/model/${id}`, {}, 'GET', null, token)

// 用户删除模型
export const deleteUserModel = (id, token) => ajax(baseUrl+`/user/model/${id}`, {}, 'DELETE', null, token)

// 用户文件
export const getUserFile = (obj, token) => ajax(baseUrl+'/user/file', obj, 'GET', null, token)

// 退出登录
export const userExit = (token) => ajax(baseUrl+'/auth/logout', {}, 'POST', null, token)

// 获取所有模型
export const getAllModel = (isCommon, size) => ajax(baseUrl+`/model?size=${size}&isCommon=${isCommon}`, {}, 'GET')

// 获取所有模型
export const getAllModelByPage = (obj, token) => ajax(baseUrl+'/model', obj, 'GET', null, token)

// 获取所有标签
export const getAllTag = (obj, token) => ajax(baseUrl+'/model/tag', obj, 'GET', null, token)

// 获取新闻列表
export const getNews = (obj, token) => ajax(baseUrl+'/news', obj, 'GET', null, token)

// 获取新闻详情
export const getNewsDetail = (id, token) => ajax(baseUrl+`/news/${id}`, {}, 'GET', null, token)

// 用户留言
export const userMessage = (obj, token) => ajax(baseUrl+'/message', obj, 'POST', null, token)

// 获取最新版本
export const getNewVersion = (obj) => ajax(baseUrl+'/version', obj, 'GET')

// 获取验证码
export const getVerifyCode = (obj) => ajax(baseUrl+'/auth/code', obj, 'POST')

// 验证码登录
export const verifyCodeLogin = (obj) => ajax(baseUrl+'/auth/phone', obj, 'POST')

// 修改密码
export const changeUserPassword = (obj, token) => ajax(baseUrl+'/user/details/password', obj, 'POST', null, token)

// 修改绑定手机号
export const changeUserPhone = (obj, token) => ajax(baseUrl+'/user/details/phone', obj, 'POST', null, token)

// 获取用户手机号
export const getUserPhone = (token) => ajax(baseUrl+'/user/phone', {}, 'GET', null, token)

// 只发送验证码
export const sendVerifyCode = (token) => ajax(baseUrl+'/user/code', {}, 'POST', null, token)

// 验证手机号
export const verifyPhone = (obj, token) => ajax(baseUrl+'/user/check', obj, 'POST', null, token)

// 验证手机后修改密码
export const changePasswordByPhone = (obj, token) => ajax(baseUrl+'/user/details/password', obj, 'POST', null, token)

// 页面开始时请求
export const getPageStart = (token, obj) => ajax(baseUrl+'/stats/visit', obj, 'GET', null, token, true)

// 页面结束时请求
export const getPageEnd = (token, obj) => ajax(baseUrl+'/stats/exit', obj, 'GET', null, token, true)

// 微信登录
export const wxLogin = (obj) => ajax(baseUrl+'/auth/weChat', obj, 'POST')

// 绑定微信
export const bindWx = (obj, token) => ajax(baseUrl+'/user/details/weChat', obj, 'POST', null, token)

// 私有模型分享
export const sharePrivateModel = (key, token) => ajax(baseUrl+`/model/share/${key}`, null, 'GET', null, token)

// 私有模型生成码
export const createPrivateModelCode = (id, token, obj) => ajax(baseUrl+`/user/model/${id}/share`, obj, 'POST', null, token)

// 编辑个人模型
export const editUserModel = (token, obj) => ajax(baseUrl+`/user/model`, obj, 'PUT', null, token)


// **************************************************************************************************************************************************************************

export const getAllModels = (obj) => ajax(baseUrl+'/app/user/downloadGenericModels', obj, 'POST')

// 登录
export const userLogin = (obj) => ajax(baseUrl+'/auth', obj, 'POST')

// 登出
export const userLogout = (obj) => ajax(baseUrl+'/app/user/updateLoginStates', obj, 'POST')

// 获取验证码
// export const getVerifyCode = (obj) => ajax(baseUrl+'/app/user/sendMessage', obj, 'POST')

// 验证码登录
// export const verifyCodeLogin = (obj) => ajax(baseUrl+'/app/user/loginMessage', obj, 'POST')

// code获取登录
export const getCodeLogin = (obj) => ajax(baseUrl+'/app/user/loginWX', obj, 'POST')

// 首次登录修改信息
export const firstLogin = (obj) => ajax(baseUrl+'/app/user/bindPhone', obj, 'POST')

// 修改密码
export const changePassword = (obj) => ajax(baseUrl+'/app/user/updatePassword', obj, 'POST')

// 注册
export const userRegister = (obj) => ajax(baseUrl+'/app/user/registerUser', obj, 'POST')

// 上传文件(加密)
export const uploadFile = (obj) => ajax(baseUrl+'/app/file/upload', obj, 'POST')

// 上传文件(不加密)
export const uploadFileNoEncrypt = (obj) => ajax(baseUrl+'/app/file/uploadNoEncrypt', obj, 'POST')

// 当前用户信息
export const userInfo = (obj) => ajax(baseUrl+'/app/easy/queryUserHtml', obj, 'POST')

// 修改用户信息
export const updateUserInfo = (obj) => ajax(baseUrl+'/app/easy/updateUserHtml', obj, 'POST')

// 微信绑定
export const wXBind = (obj) => ajax(baseUrl+'/app/user/bindOpenId', obj, 'POST')

// 当前用户的项目列表
export const userProjectList = (obj) => ajax(baseUrl+'/app/easy/queryClientUserFileByAccount', obj, 'POST')

// 当前用户模型
export const getUerModelList = (obj) => ajax(baseUrl+'/app/easy/queryUserNameByAccount', obj, 'POST')

// 删除当前用户下的模型
export const deleteUerModel = (obj) => ajax(baseUrl+'/app/user/deleteUserModel', obj, 'POST')

// 当前用户下的项目
export const getUserProject = (obj) => ajax(baseUrl+'/app/easy/queryClientUserFileByAccount', obj, 'POST')

// 文件上传
export const fileUpload = (params,formData) => ajax(baseUrl+'/app/file/upload'+'?token='+params, formData, 'POST')

// 删除当前用户下的文件
export const deleteUserFile = (obj) => ajax(baseUrl+'/app/easy/deleteClientUserFile', obj, 'POST')

// 收藏模型
export const collectModel = (obj) => ajax(baseUrl+'/app/model/collection', obj, 'POST')

// 当前用户收藏的模型
export const getUserCollectUserModel = (obj) => ajax(baseUrl+'/app/easy/queryCollectionUserModelHtml', obj, 'POST')

// 当前用户收藏的模型
export const getUserCollectNormalModel = (obj) => ajax(baseUrl+'/app/easy/queryCollectionModelHtml', obj, 'POST')

// 取消模型收藏
export const cancelUserCollectUserModel = (obj) => ajax(baseUrl+'/app/model/cancel', obj, 'POST')

// 模型上传
export const uploadUserModel = (obj) => ajax(baseUrl+'/app/easy/createUserModelFile', obj, 'POST')

// 获取所有标签类型
export const getAllTagType = (obj) => ajax(baseUrl+'/app/easy/queryAllLabelManageForSelect', obj, 'POST')

// 获取全部通用模型
export const getAllNormalModel = (obj) => ajax(baseUrl+'/app/easy/queryModelByHtml', obj, 'POST')

// 获取全部用户模型
export const getAllUserModel = (obj) => ajax(baseUrl+'/app/easy/queryUserModelByHtml', obj, 'POST')

// 模型详情
export const getModelDetail = (obj) => ajax(baseUrl+'/app/easy/queryModelDetailHtml', obj, 'POST')

// 用户模型详情
export const getUserModelDetail = (obj) => ajax(baseUrl+'/app/easy/queryUserModelDetailHtml', obj, 'POST')

// 获取新闻
// export const getNews = (obj) => ajax(baseUrl+'/app/easy/queryNews', obj, 'POST')

// 版本获取
export const getVersion = (obj) => ajax(baseUrl+'/app/user/queryVersion1',obj, 'GET')

// 获取文件信息
export const getFileInfo = (obj) => ajax(baseUrl+'/app/user/queryJsonFileById', obj, 'GET')

// import http from './ajax'
// // 登录
// export const userLogin = (params) => {
//     return http.fetchPost(baseUrl+'/app/user/login',params)
// }

// // 所有模型列表
// export const getAllModels = (params) => {
//   return http.fetchPost(baseUrl+'/app/user/downloadGenericModels', params)
// }

// export const postPets = (obj) => {
//   return http.fetchPost('http://127.0.0.1:4523/m1/3664171-0-default/pet',obj)
// }